export const TRIVIA_ROUND_QUESTION_COUNT = 10;

export const triviaDefinition = {
  id: 'arcade-trivia',
  name: 'Arcade Trivia',
  summary: 'Pick a category, answer together, and enjoy quick facts at a family pace.',
  instructions: 'Choose a category, then answer with number keys, Enter, Space, or touch.',
  storageNamespace: 'arcade-trivia',
  themeClass: 'theme-arcade-trivia',
  roundQuestionCount: TRIVIA_ROUND_QUESTION_COUNT,
};
